import React from 'react';
import {
    Layout, Menu, Breadcrumb, Icon,
  } from 'antd';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";

import '../../assets/css/App.css';
import Background from "../../assets/images/BGmifa.jpg";
import Header1 from '../public';

const { SubMenu } = Menu;
const {
  Header, Content, Footer, Sider,
} = Layout;


class MIFA extends React.Component{
    constructor(props){
        super(props);
        this.state={

        }
    }
    render(){
        return(
            <div className='Login-component'>
            <Header1></Header1>
            <Content style={{ padding: '0 50px' }}>

              <Layout style={{background: '#fff' }}>
                <Sider width={200} style={{ background: '#fff' }}>
                  <Menu
                    mode="inline"
                    defaultSelectedKeys={['0']}
                    defaultOpenKeys={['sub1']}
                    style={{ height: '100%' }}
                  >
                    <SubMenu key="sub1" title={<span><Icon type="user" />Atlas</span>}>
                    <Menu.Item key="2"><Link to="/mifa-intro">Introduction</Link></Menu.Item>
                      <Menu.Item key="1"><Link to="/mifa-correlation">Correlation</Link></Menu.Item>
                    </SubMenu>
                  </Menu>
                </Sider>
                <Content >
                       
                <div>
                <div style={{background: `url(${Background}) no-repeat center center`,height:300,backgroundSize: "cover",}}>
                <div style={{textAlign:"center",color:"#fff"}}>
                <br></br><br></br>
                  <txt style={{fontSize:60,fontWeight:'bold'}}>THE CIITOOL PLATFORM</txt> <br></br>
                  <txt style={{fontSize:45,fontWeight:'bold',}}>Discovering Cancer Phenotype</txt>
                  </div>
                </div>


                <div>
                <br></br>
                <br></br>
                <txt style={{fontSize:30,fontWeight:'bold',paddingLeft:150,paddingRight:100}}>Decoding medical imaging feature for human cancer</txt>
                <br></br>
                <div style={{fontSize:20,paddingLeft:150,paddingRight:200}}>
                <txt >
                <br></br>
                 Medical images are increasingly considered a credible tool for assisting in the detection and treatment of human diseases, particularly cancer. It has evolved from X-ray imaging, the original imaging modality, to modern multimodality imaging that allow real-time image acquisition with high resolution <txt style={{fontStyle :"italic"}}>[1]</txt>. Utilization of medical images for assisting cancer analysis is currently recommended in 83% of clinical practice guidelines.
                 <br></br><br></br>Conventional cancer analysis based on medical images is generally dependent on the radiologists’ experience. This imaging workflow is inherently subjective, and prone to inter-observer bias, this has prompted development of automatic image feature analysis techniques to make this process more accessible and objective<txt style={{fontStyle :"italic"}}>[2]</txt>. Based on the delineation of regions of interest (ROI) on medical images, numerous imaging features can be extracted through automatic decoding techniques, to assist clinicians<txt style={{fontStyle :"italic"}}>[3]</txt>. In the last few decades, thousands of quantitative/qualitative engineered features on medical images obtained by computed tomography (CT), magnetic resonance imaging (MRI), positron emission tomography (PET), histopathology, mammogram, and other imaging modalities, have been identified<txt style={{fontStyle :"italic"}}>[4]</txt>. From the basic radiographic parameters of size, diameter, and color, to the high-throughput intra-tumor heterogeneity descriptors that go beyond the subjective knowledge of clinicians, such as wavelet transform, imaging features have provided valuable information for solving hundreds of tasks pertaining to dozens of cancer types<txt style={{fontStyle :"italic"}}>[5]</txt>.
                 <br></br><br></br>The traditional, predefined feature systems do not generally meet the stringent requirements for clinical utility, while deep learning approaches require further work before they can be translated into clinical use. Studies using medical images to extract quantitative or qualitative imaging features to aid in cancer-related clinical practice were reviewed in this study. The primary aim of our study is to propose a specification imaging feature map for each of the cancer-related tasks, guiding future medical imaging studies on human cancers.
                 
                 <br></br><br></br>Please cite the following study if use the information in this website:
                 <br></br><br></br><txt style={{fontStyle:'italic'}}>Lu Wang, et al. and Jiangdian Song*. Decoding and Systematization of Medical Imaging Features of Multiple Human Malignancies. Radiology: Imaging Cancer, 2020, 2(5): e190079.</txt><br></br>
                 
                 <br></br><br></br><txt style={{fontWeight:'bold'}}>Reference:</txt><br></br>
                [1]	Merkow RP, Korenstein D, Yeahia R, Bach PB, Baxi SS. Quality of Cancer Surveillance Clinical Practice Guidelines: Specificity and Consistency of Recommendations. JAMA internal medicine. 2017;177(5):701-709.
                <br></br>[2]	Gillies RJ, Kinahan PE, Hricak H. Radiomics: Images Are More than Pictures, They Are Data. Radiology. 2016;278(2):563-577.
                <br></br>[3]	Aerts HJ, Velazquez ER, Leijenaar RT, et al. Decoding tumour phenotype by noninvasive imaging using a quantitative radiomics approach. Nature communications. 2014;5:4006.
                <br></br>[4]	Mackin D, Fave X, Zhang L, et al. Measuring Computed Tomography Scanner Variability of Radiomics Features. Investigative radiology. 2015;50(11):757-765.
                <br></br>[5]	Beck AH, Sangoi AR, Leung S, et al. Systematic analysis of breast cancer morphology uncovers stromal features associated with survival. Science translational medicine. 2011;3(108):108ra113.

                </txt>
                </div>
                </div>
                </div>





                </Content>
              </Layout>
            </Content>
            </div>
        )
    }
}
export default MIFA;